import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import utils from 'Utils';
import Accordion from 'Components/accordion';
import SelectIndicatorsInput from 'Components/selectIndicatorsInput';
import getActiveCategoriesViaParent
  from 'Selectors/getActiveCategoriesViaParent';
import * as styles from './selectIndicators.css';

const { mapKV } = utils.obj;

const renderChildren = (children) => mapKV(
  children,
  ({ name: catName, indicators }) => ({ catName, indicators }),
  true
).map(({ catName, indicators }) => (
  <Accordion
    name={catName}
    key={catName}
    visible
    className={styles.subCategoryHeader}
  >
    <ul className={styles.ul}>
      { indicators.map((id) => (
        <SelectIndicatorsInput id={id} key={id} />
      )) }
    </ul>
  </Accordion>
));

const SelectIndicators = ({ parentCategories }) => (
  <ul>
    { mapKV(parentCategories, (obj, key) => ({ ...obj, key }), true)
      .map(({ name, children, key }, idx) => (
        <li className={styles.indicators} key={key}>
          <h2 className={styles.categoryHeader}>{name}</h2>
          { renderChildren(children, idx) }
        </li>
      )) }
  </ul>
);

SelectIndicators.propTypes = {
  // @TODO expand this to full typecheck
  parentCategories: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  parentCategories: getActiveCategoriesViaParent(state),
});

export default connect(mapStateToProps)(SelectIndicators);

// Testing exports
export {
  SelectIndicators,
  mapStateToProps,
};



// WEBPACK FOOTER //
// ./app/components/selectIndicators/index.js